import styled from '@emotion/styled';

// 메인 폼 컨테이너
export const SignupFormContainer = styled.form`
    width: 400px;
    margin: 50px auto;
    padding: 40px 20px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

// 폼 제목
export const FormTitle = styled.h1`
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    color: #333;
    margin-bottom: 40px;
`;

// 입력 섹션
export const InputSection = styled.div`
    margin-bottom: 24px;
`;

// 라벨
export const Label = styled.label`
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
`;

// 입력 그룹 (아이디 + 중복확인 버튼)
export const InputGroup = styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
`;

// 기본 입력 필드
export const Input = styled.input`
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }

    &::placeholder {
        color: #999;
    }
`;

// 아이디 입력 필드
export const IdInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }

    &::placeholder {
        color: #999;
    }
`;

// 중복확인 버튼
export const CheckButton = styled.button`
    padding: 12px 20px;
    background: #002755;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    flex-shrink: 0;
    box-sizing: border-box;

    &:hover {
        background: #003366;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }

    &:disabled {
        background: #6c757d;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
`;

// 셀렉트 박스
export const Select = styled.select`
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    background: white;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }
`;

// 기타 입력 필드
export const EtcInput = styled.input`
    width: 100%;
    margin-top: 12px;
    padding: 12px 16px;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }

    &::placeholder {
        color: #999;
    }
`;

// 메시지 (에러/성공)
export const Message = styled.p`
    margin-top: 8px;
    font-size: 13px;
    font-weight: 500;
    color: ${(props) => {
        if (props.isError) return '#dc3545';
        if (props.isSuccess) return '#28a745';
        return '#6c757d';
    }};
`;

// 제출 버튼
export const SubmitButton = styled.button`
    width: 100%;
    padding: 8px;
    background: #002755;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 32px;

    &:hover {
        background: #003366;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 39, 85, 0.3);
    }

    &:active {
        transform: translateY(0);
    }

    &:disabled {
        background: #6c757d;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
`;

// 회원가입 섹션
export const SignupSection = styled.div`
    text-align: center;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #e1e5e9;
`;

export const SignupText = styled.p`
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
`;

export const SignupButton = styled.button`
    padding: 8px 16px;
    background: transparent;
    color: #002755;
    border: 2px solid #002755;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #002755;
        color: white;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 39, 85, 0.2);
    }

    &:active {
        transform: translateY(0);
    }
`;
